import { camelizeKeys } from 'humps';
import { prop } from 'ramda';
import { post } from '@namespace/helpers';

type GetJackpotGeneralTypeParams = { serviceId: string };

// todo type getJackpotGeneral return
export const getJackpotGeneral = ({ serviceId }: GetJackpotGeneralTypeParams) =>
  post('/isw/api/v2/jackpot/get', {
    service_id: serviceId
  })
    .then(camelizeKeys)
    .then(prop('jackpot'));
